
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ redirectPath = '/', allowedRoles = null, requireTenant = false, children }) => {
    const location = useLocation();
    const { isAuthenticated, isInitializing, user, activeTenantId, isImpersonating } = useAuth();

    // Wait for auth state to be restored before checking route protection
    if (isInitializing) {
        return null;
    }

    // Check if authenticated
    if (!isAuthenticated) {
        return <Navigate to={redirectPath} replace state={{ from: location }} />;
    }

    // Check if role is allowed
    const roleAllowed = allowedRoles && allowedRoles.length > 0 ? allowedRoles.includes(user?.role) : true;
    const isSuperAdminImpersonatingTenant =
        user?.role === 'SuperAdmin' &&
        isImpersonating &&
        Array.isArray(allowedRoles) &&
        (allowedRoles.includes('Admin') || allowedRoles.includes('Manager'));

    if (!roleAllowed && !isSuperAdminImpersonatingTenant) {
        // Redirect to appropriate landing page based on role
        const landingPath = user?.role === 'SuperAdmin' ? '/super-admin' : '/dashboard';
        return <Navigate to={landingPath} replace />;
    }

    // Check if tenant is required but not selected
    if (requireTenant && !activeTenantId) {
        const landingPath = user?.role === 'SuperAdmin' ? '/super-admin' : '/';
        return <Navigate to={landingPath} replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
